import { MovieClip } from '@play-co/timestep-core/ui';
import { ButtonScaleViewOpts } from 'src/lib/ui/components/ButtonScaleView';
import {
  match2BundleSaleGetRemainingTime,
  match2BundleSaleIsAvailable,
} from 'src/replicant/match2/bundlesale/match2-bundlesale.getters';
import { now, user } from 'src/StateObserver';
import { bundleSaleTheme } from './match2-bundlesale.theme';
import { AssetGroup } from '@play-co/timestep-core';
import { FeatureButton } from 'src/game/components/FeatureButton';

const defaultButtonUrl = 'assets/ui/match2/bundlesale/button';

const assets = {
  movieclip: {
    url: defaultButtonUrl,
    loadMethod: MovieClip.animationLoader,
  },
};

export class Match2BundleSaleButtonAnimated extends FeatureButton {
  constructor(opts: ButtonScaleViewOpts) {
    super({
      width: 144,
      height: 160,
      pressedOffsetY: 5,
      labelPanel: {
        ...bundleSaleTheme().getStyle('button_timer'),
      },
      ...opts,
    });

    const altButton = bundleSaleTheme().getAsset('button');
    assets.movieclip.url = altButton ? altButton : defaultButtonUrl;

    this.animationStateMap = {
      main: {
        type: 'movieclip',
        assetGroup: new AssetGroup(Object.values(assets)),
        url: assets.movieclip.url,
        sequence: ['sale_spawn', 'sale_loop'],
        scale: 0.65,
        offsetY: 3,
      },
    };
  }

  public update() {
    // Check if bundle sale feature is active and if there is an ongoing event.
    // Hide the button if not.
    if (!match2BundleSaleIsAvailable(user(), now())) {
      this.hide();
      return;
    }

    // Show the button if the bundle sale become available
    this.show();
    this.setLabelTime({ duration: match2BundleSaleGetRemainingTime(now()) });
    this.setAnimationState('main');
  }
}
